import React /*, { useState, useEffect }*/ from 'react';
// import 'bootstrap/dist/css/bootstrap.css'
// import '../error.css'


const ErrorPage = ({errorNo, errorTitle}) => {


  return (
    <div className="error-container">
      <div className="error-template">
          <h1>Error !!!</h1>
          <h2>{errorNo} {errorTitle}</h2>
          <div className="error-details">
          </div>
      </div>
  </div>
  )
}

export default ErrorPage;